module.exports = __webpack_public_path__ + "img/img-7.dc203ef8.png";